import { RequestConfig } from '@/interface'

const PRIFIX = 'fpgl/xmxx/'
const itemsInfoConfig: RequestConfig = {
  // add 添加或更新项目
  addOrUpdate: {
    url: `${PRIFIX}addOrUpdate`,
    method: 'post'
  },
  // childrenNodes 子节点
  childrenNodes: {
    url: `${PRIFIX}childrenNodes`,
    method: 'post'
  },
  // 列表
  xmxxFindPageList: {
    url: `${PRIFIX}findPageList`,
    method: 'post'
  },
  // 最近开票记录
  nearSsflbm: {
    url: `${PRIFIX}nearSsflbm`,
    method: 'post'
  },
  // parentNode 父节点
  parentNode: {
    url: `${PRIFIX}parentNode`,
    method: 'post'
  },
  // 税收分类编码搜索
  ssbmSearch: {
    url: `${PRIFIX}search`,
    method: 'post'
  },
  // ssflbmInfo
  ssflbmInfo: {
    url: `${PRIFIX}ssflbmInfo`,
    method: 'post'
  },
  // 项目信息删除
  xmxxDel: {
    url: `${PRIFIX}xmxxDel`,
    method: 'post'
  },
  // 新增项目详情
  xmxxInfo: {
    url: `${PRIFIX}xmxxInfo`,
    method: 'post'
  },
  // 智能赋码
  znfm: {
    url: `${PRIFIX}znfm`,
    method: 'post'
  },
  // 项目信息查询
  xmxxcx: {
    url: `${PRIFIX}xmxxcx`,
    method: 'post'
  },
  // 批量智能赋码
  znfmColl: {
    url: `${PRIFIX}znfmColl`,
    method: 'post'
  },
  // 项目信息批量导入
  xmxxUpload: {
    url: `${PRIFIX}xmxxUpload`,
    method: 'post'
  },
  // 项目信息上传结果查询
  xmxxUploadList: {
    url: `${PRIFIX}xmxxUploadList`,
    method: 'post'
  },
  // 项目信息上传状态查询
  xmxxUploadResult: {
    url: `${PRIFIX}xmxxUploadResult`,
    method: 'post'
  },
  // 批量新增适用企业
  batchUpdateNsrsbhs: {
    url: `${PRIFIX}batchUpdateNsrsbhs`,
    method: 'post'
  }
}
export default itemsInfoConfig
